import { SelectProps } from 'antd';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import { useState } from 'react';
import { useDebounce } from '@/hooks';
import InfiniteSelect from '@/components/_common/InfiniteSelect';
import { ListCompaniesQuery } from '@/core/domain/enterprise/Companies/Companies.types';
import {
  useCostCenter,
  useCostCenters,
} from '@/core/domain/enterprise/CostCenter/CostCenter.hooks';

type Props = Omit<SelectProps, 'options'> & {
  queryFilter?: ListCompaniesQuery;
};

const CostCenterInfiniteSelectField: React.FC<Props> = ({
  queryFilter,
  ...props
}) => {
  const [searchValue, setSearchValue] = useState<string>();
  const search = useDebounce(searchValue);

  const { data, isLoading, hasNextPage, fetchNextPage } = useCostCenters({
    ...queryFilter,
    active: true,
    rows: 30,
    description: search,
  });

  const costCenter = flatInfiniteData(data);

  const { data: detail } = useCostCenter(
    props.mode !== 'multiple' ? props.value : undefined,
  );

  const options =
    detail && !costCenter?.find((item) => item.id === detail.id)
      ? [...(costCenter || []), detail]
      : costCenter;

  const costCenterOptions = options.map((cur) => ({
    value: cur.id,
    label: cur.description,
  }));

  return (
    <InfiniteSelect
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      loading={isLoading}
      options={costCenterOptions}
      showSearch
      searchValue={searchValue}
      filterOption={false}
      onSearch={setSearchValue}
      {...props}
    />
  );
};

export default CostCenterInfiniteSelectField;
